export default __webpack_public_path__ + "static/media/Profile Icon.28f74a8b.svg";